<ng-container>
  <div class="panel">
    <div class="row">
      <div class="container">
        <div class="col-sm-1"></div>
        <div class="title-container">
          <b class="title">Estándares de Competencia Acreditados</b>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="container">
        <div class="col-sm-1"></div>
        <div class="col-sm-10 leyenda1">
          <p>{{ nameStandard ? nameStandard : "N/A" }}</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="container">
        <div class="col-sm-1">
          <br />
          &nbsp;
          <span
            ><img src="./assets/images/icon/lupa.png" class="iconLupa"
          /></span>
        </div>
        <div class="col-sm-11">
          <mat-form-field appearance="standard">
            <mat-label> Buscar</mat-label>
            <input
              matInput
              (keyup)="applyFilter($event)"
              placeholder="Buscar"
              #input
              oninput="this.value = this.value.toUpperCase()"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
    <br />

    <div class="row">
      <div class="container">
        <div class="col-sm-12 example-container">
          <div class="mat-elevation-z8">
            <table
              mat-table
              [dataSource]="dataSource"
              matTableExporter
              #exporter="matTableExporter"
              class="table table-striped table-bordered"
            >
              <ng-container matColumnDef="codigo">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                  Código
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="sectorByID(element)"
                  class="letraE"
                >
                  {{ element.codigoEstadarCompetencia }}
                </td>
              </ng-container>

              <ng-container matColumnDef="titulo">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                  Título
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="sectorByID(element)"
                  class="letraE_icon"
                >
                  {{ element.tituloEstadarCompetencia }}
                </td>
              </ng-container>

              <ng-container matColumnDef="comite">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                  Comité
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="standarById(element)"
                  class="letraE_icon"
                >
                  {{ element.nombreComite }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>

         

            <div *ngIf="activeEror" class="no-data">
              <p>No se encontraron registros</p>
            </div>

            <br />
          </div>
        </div>
      </div>

      <div class="container">
        <mat-paginator
          [length]="totalElements"
          [pageSize]="pageSize"
          (page)="onPageChange($event)"
          showFirstLastButtons
        >
        </mat-paginator>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="container">
      <div class="col-sm-5"></div>
      <div style="text-align: center" class="col-sm-1">
        <button mat-button (click)="close()">
          <img src="./assets/images/icon/Atras.png" class="imagen" />
        </button>
      </div>
      <div style="text-align: center" class="col-sm-1">
        <button mat-button (click)="close()">
          <img src="./assets/images/icon/Home.png" class="imagen" />
        </button>
      </div>
    </div>
  </div>
</ng-container>

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#ee0909"
  type="ball-atom"
  [fullScreen]="true"
>
  <p style="color: white">cargando ....</p>
</ngx-spinner>
